import { render, staticRenderFns } from "./Donor.old.vue?vue&type=template&id=6a09a1e8"
import script from "./Donor.old.vue?vue&type=script&lang=js"
export * from "./Donor.old.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports